export const environment = {
  production: true,
  tenant: 'activities_MYS',
  fallbackLocale: 'en-MY',
  widget: false,
  serviceWorker: {
    enable: true,
  },
  e2e: {
    // enable e2e mode with data-test markup
    enable: true,
  },
  applications: {
    datadog: {
      applicationId: 'f2062e7c-738c-4e68-80c7-431aede71afb',
      clientToken: 'pub479f0afae0f5f45fa57ee25866064036',
    },
    cdn: {
      host: 'https://activities-assets.decathlon.net/legacy',
      root: 'https://activities-assets.decathlon.net',
    },
    phrase: {
      locales: {
        'en-MY': '',
      },
    },
    front: {
      url: 'https://activities.decathlon.my',
      domain: 'activities.decathlon.my',
    },
    woosmap: {
      apiKey: 'woos-6e588fc5-a1e3-3d39-9ee1-28b713fdd5df',
      gmapApiKey: 'AIzaSyDG3jq0cm9JoLe9E8PCAZaawAHrfQ7U_ss',
      locale: 'country:my',
    },
    amplitude: {
      apiKey: 'c06224e8147966f6ffae12a7f2d7d198',
    },
    gtm: {
      id: 'GTM-MTM3WV9',
    },
    sentry: {
      dsn: 'https://0fc1729944bc4fa1a21e1cab26bd34ad@sentry.io/1396593',
      environment: 'production-MYS',
      enabled: true
    },
    talkjs: {
      appId: 'QFqHH3hk',
    },
    activities: {
      url: 'https://api-eu.decathlon.net/activities/v2',
      api_key: '02360fa4-56c6-4ad3-b1f0-c4fa1ea950e2',
    },
    strapi: {
      url: 'https://activities.decathlon.my/strapi-api',
      locale: 'en',
    },
    stripe: {
      apiKey: 'pk_live_51KnHm6A73kGuXDaHM2M834YaQNIjRPNQgwHqdolaKPBA1JTdSjL67rzryL2Hfw2KDsh2fy3ArvcIIG0Dcgl8II5G00yOwQnDH8',
      authorizeUri: 'https://connect.stripe.com/express/oauth/authorize',
      apiUrl: 'https://connect.stripe.com',
    },
    pfs: {
      url: 'https://europe-west1-services-platform-pwlg.cloudfunctions.net/api'
    },
    advice: {
      url: 'https://api-global.decathlon.net/cms',
      apiKey: 'c1bd69cf-9822-49be-819a-a42dd47cb043',
    },
    reviews: {
      url: 'https://reviews.decathlon.com',
    },
    onepay: {
      host: 'https://onepay-widget.decathlon.net',
    },
  },
  auth: {
    fed: {
      issuer: 'https://idpdecathlon.oxylane.com',
      redirectUri: 'https://activities.decathlon.my/auth/redirection',
      clientId: 'Cc73544e2464f2bbb5585c8508f0d4ceba0afa720',
      userinfoEndpoint:
        'https://idpdecathlon.oxylane.com/idp/userinfo.openid',
      discoveryDocument:
        'https://idpdecathlon.oxylane.com/.well-known/openid-configuration',
    },
    connect: {
      issuer: 'https://api-eu.decathlon.net/connect',
      redirectUri: 'https://activities.decathlon.my/auth/redirection',
      clientId: 'edc7a611-0caa-4352-bc24-d07a53d65277',
      discoveryDocument:
        'https://api-global.decathlon.net/connect/.well-known/openid-configuration',
      logoutRedirectionUrl: 'https://activities.decathlon.my/auth/logout',
    },
  },
};
